import { apiClient } from './client'

// ============================================================================
// Public types — wire format with the backend
// ============================================================================

export interface BriefingApplicationRequest {
  sessionId: string
  name: string
  phone: string
  franchiseTypes: Array<'academy' | 'tutoring'>
  sido?: string
  sigungu?: string
  interests: string[]
  otherText?: string
  privacyConsent: boolean
  marketingConsent: boolean
}

export interface FranchiseInquiryRequest {
  name: string
  phone: string
  franchiseTypes: Array<'academy' | 'tutoring'>
  sido?: string
  sigungu?: string
  inquiryText: string
  privacyConsent: boolean
  marketingConsent: boolean
}

interface CreateResponse { id: number }

interface ApiEnvelope<T> {
  success: boolean
  data: T
  error: { code: string; message: string } | null
}

export interface BriefingSession {
  sessionId: string
  startsAt: string
  endsAt: string
  applicationClosesAt: string
  mode: 'offline' | 'online'
  applicationAvailability: 'open' | 'full' | 'closed'
}

// ============================================================================
// Public submit calls
// ============================================================================

export const lcMarketingApi = {
  submitBriefingApplication: async (
    payload: BriefingApplicationRequest,
  ): Promise<CreateResponse> => {
    const res = await apiClient.post<ApiEnvelope<CreateResponse>>(
      '/v1/public/lc-marketing/briefing-applications',
      payload,
    )
    return res.data.data
  },

  submitFranchiseInquiry: async (
    payload: FranchiseInquiryRequest,
  ): Promise<CreateResponse> => {
    const res = await apiClient.post<ApiEnvelope<CreateResponse>>(
      '/v1/public/lc-marketing/franchise-inquiries',
      payload,
    )
    return res.data.data
  },

  getBriefingSessions: async (): Promise<BriefingSession[]> => {
    const res = await apiClient.get<ApiEnvelope<BriefingSession[]>>(
      '/v1/public/lc-marketing/briefing-sessions',
    )
    return res.data.data
  },
}
